<template>
  <div class="lessonDetail" ref="content">
    <titleBar
      :title="title"
      :tabs="tab_cur"
      :tabs_arr="tabs_arr"
      @tab_click="tab_click"
      ref="title_bar"
    ></titleBar>
    <div class="headItem" v-if="data">
      <div class="item">
        <h2>
          <i v-if="data.subject == 0">数</i>
          <i v-else-if="data.subject == 1">语</i>
          <i v-else-if="data.subject == 2">英</i>
          {{data.productName}}
        </h2>
        <div class="timeItem">
          <span>{{data.startToEnd}}</span>
          <span v-if="data.weekdays && data.weekdays.split('、').length == 7">每天 {{data.dayTime}}</span>
          <span v-else-if="data.weekdays && data.weekdays.split('、').length > 3">每周{{data.dayTime}}</span>
          <span
            v-else-if="data.weekdays && data.weekdays.split('、').length <= 3"
          >每周{{data.weekdays}} {{data.dayTime}}</span>
        </div>
        <p class="lesson_num">共{{data.customData.lessonCount}}课时</p>
        <div class="lesson_item_mes">
          <div class="box">
            <img :src="data.customData.lecturerImage.url" />
            <div class="r_box">
              <span class="name">{{data.customData.lecturerImage.name}}</span>
              <span class="role">主讲</span>
            </div>
          </div>
          <div class="box">
            <img :src="data.customData.adviserImage.url" />
            <div class="r_box">
              <span class="name">{{data.customData.adviserImage.name}}</span>
              <span class="role">辅导（报名剩余{{data.stock}}个名额）</span>
            </div>
          </div>
        </div>
      </div>
      <p class="line"></p>
      <div class="tagItem">
        <p v-if="data.customData.featureIdList && data.customData.featureIdList.length != 0">
          <i>特色</i>
          <span
            v-for="(item, index) in data.customData.featureIdList"
            v-if="index < 3"
          >{{item.value}}</span>
        </p>
        <p v-if="data.partsList && data.partsList.length != 0">
          <i>赠品</i>
          <span v-for="(item, index) in data.partsList" v-if="index < 3">{{item.value}}</span>
        </p>
        <p class="arrow" @click="remind_event" v-if="data.customData.announce">
          <i>声明</i>
          {{data.customData.announce}}
        </p>
      </div>
    </div>
    <div class="content" ref="lesson_detail" v-if="data">
      <p class="title">
        <i></i>课程详情
      </p>
      <img
        v-for="(item, index) in data.detail.introduceImageList"
        class="lesson_img"
        :style="{height: item.h_ + 'px'}"
        :src="item.url"
      />
    </div>
    <div class="content" ref="lesson_program" v-if="data">
      <p class="title mb_20">
        <i></i>
        课程大纲 （{{data.customData.outline.length}}课时）
        <span class="more" @click="program_event" v-if="data.customData.outline.length > 3">查看所有</span>
      </p>
      <div class="list" v-for="(item, index) in data.customData.outline" v-if="index<3">
        <span class="fl">第{{index + 1}}课</span>
        <div class="fl">
          <p>{{item.title}}</p>
          <p>{{item.courseTime}}</p>
        </div>
      </div>
    </div>
    <div class="content" ref="lesson_teacher" v-if="data">
      <p class="title">
        <i></i>老师介绍
      </p>
      <div class="teacher_mes">
        <img class="fl" :src="data.customData.lecturerImage.url" />
        <div class="right_box">
          <h3>{{data.customData.lecturerImage.name}}</h3>
          <div class="tag_item">
            <span
              v-for="(item, index) in data.customData.lecturerImage.label"
              v-if="index < 3"
            >{{item}}</span>
          </div>
          <p>{{data.customData.lecturerImage.description}}</p>
        </div>
      </div>
    </div>
    <div v-if="tips" class="mark" @click="close_tips" @touchmove.prevent>
      <div v-if="tips == 'tips_middle'" class="tips_middle" @click.stop>
        <h3>上课时间存在冲突</h3>
        <p>
          你已经报名该时段其他课程
          <br />是否继续？
        </p>
        <div class="btn">
          <span>继续</span>
          <span>取消</span>
        </div>
      </div>
      <div class="tips_bottom" @click.stop>
        <div v-if="tips == 'remind'" class="remind">
          <h2>声明</h2>
          <div ref="announce" class="announce_item">
            <h3>{{data.customData.announce}}</h3>
          </div>
        </div>
        <div v-if="tips == 'method'" class="method">
          <h2>上课方式</h2>
          <p>
            1.电脑：浏览器打开官网
            <span @click="copy_event">复制网址</span>
          </p>
          <p>2.手机/pad：应用市场内下载小象辅导APP</p>
          <p>
            3.如有疑问可咨询人工客服
            <span>
              <a @click="call_event">拨打电话</a>
            </span>
          </p>
          <p>记得使用家长盒子的注册手机号登录哦～</p>
        </div>
      </div>
    </div>
    <p v-if="toast" class="toast">{{toast}}</p>
    <div v-if="load" class="load_item">
      <img src="../../assets/images/common/shu.gif" />
      <p>加载中...</p>
    </div>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
    <lesson_bottom :tips="false" :bottem_mes="bottem_mes" @pay_event="click_pay"></lesson_bottom>
  </div>
</template>

<script>
import ajax from "@/api/ajax";
import utils from "@/assets/js/utils";
import lesson_loading from "@/components/common/lesson_loading.vue";
import titleBar from "@/components/common/titleBar.vue";
import lesson_bottom from "@/components/common/lessonBottom.vue";
import BSroll from "better-scroll";
let vm = null;
window.callback = function(obj) {
  vm.creatOrder(JSON.parse(obj));
};
export default {
  name: "",
  data() {
    return {
      title: "课程详情",
      tips: "",
      detail_offsetTop: "",
      program_offsetTop: "",
      teacher_offsetTop: "",
      tab_cur: "detail",
      tabs_arr: { 课程: "detail", 大纲: "program", 老师: "teacher" },
      data: "",
      bottem_mes: {},
      loadingLock: true,
      status: "loading",
      token: "",
      sourceId: "",
      version: "",
      source: "",
      toast: "",
      btn_status: true,
      orderId: "",
      scroll: null,
      load: false
    };
  },
  watch: {
    data: function() {
      let self = this;
      this.$nextTick(function() {
        let title_height = self.$refs.title_bar.$el.clientHeight;
        self.detail_offsetTop =
          self.$refs.lesson_detail.offsetTop - title_height;
        self.program_offsetTop =
          self.$refs.lesson_program.offsetTop - title_height;
        self.teacher_offsetTop =
          self.$refs.lesson_teacher.offsetTop - title_height;
        window.addEventListener("scroll", self.handleScroll);
      });
    },
    toast(newName, oldName) {
      let self = this;
      console.log(newName);
      if (newName != "") {
        setTimeout(function() {
          self.toast = "";
        }, 2000);
      }
    }
  },
  methods: {
    exit_event: function() {
      return this.$router.go(-1);
    },
    remind_event: function() {
      let self = this;
      this.tips = "remind";
      this.$nextTick(function() {
        self.scroll = new BSroll(self.$refs.announce, {
            click: true
        });
      });
    },
    close_tips: function() {
      this.tips = "";
    },
    program_event: function() {
      this.$router.push({
        path:
          "/lesson/program_list?token=" +
          this.token +
          "&sourceId=" +
          this.sourceId +
          "&version=" +
          this.version +
          "&source=" +
          this.source
      });
    },
    handleScroll: function() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= this.teacher_offsetTop) {
        this.title = "";
        this.tab_cur = "teacher";
      } else if (scrollTop >= this.program_offsetTop) {
        this.title = "";
        this.tab_cur = "program";
      } else if (scrollTop >= this.detail_offsetTop) {
        this.title = "";
        this.tab_cur = "detail";
      } else {
        this.title = "课程详情";
        this.tab_cur = "detail";
      }
    },
    tab_click: function(tab) {
      let scrollTop;
      switch (tab) {
        case "detail":
          scrollTop = this.detail_offsetTop;
          break;
        case "program":
          scrollTop = this.program_offsetTop;
          break;
        case "teacher":
          scrollTop = this.teacher_offsetTop;
          break;
      }
      window.scrollTo(0, scrollTop);
    },
    initData: async function() {
      let self = this;
      const [resp] = await ajax.all([
        ajax.get("/parent/live/get-goods-info", {
          params: {
            token: self.token,
            sourceId: self.sourceId,
            productSource: 1,
            version: self.version,
            source: self.source
          }
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        this.data = resp.data.data;
        let introduceImageList = this.data.detail.introduceImageList;
        for (let i = 0; i < introduceImageList.length; i++) {
          let w_width = window.innerWidth * 2;
          introduceImageList[i].h_ =
            introduceImageList[i].height /
            ((introduceImageList[i].width / w_width) * 2);
          self.data.detail.introduceImageList = introduceImageList;
        }
        this.$nextTick(() => {
          window.scrollTo(0, 1);
          window.scrollTo(0, 0);
        });
        this.checkOrder();
      } else {
        this.loadingLock = true;
        this.status = "error";
      }
    },
    checkOrder: async function() {
      let self = this;
      const [resp] = await ajax.all([
        ajax.get("/parent/live/check-product-order", {
          params: {
            token: self.token,
            source: self.source,
            version: self.version,
            productIds: self.data.productId
          }
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        self.loadingLock = false;
        let order_data = resp.data.data;
        self.orderId = order_data.productList[self.data.productId].orderId;
        this.bottem_mes = {
          originalPrice: self.data.originPrice / 100,
          salePrice: self.data.salePrice / 100,
          stockCount: self.data.stock,
          order_status: order_data.productList[self.data.productId].orderState,
          btn_status: self.btn_status
        };
        utils.sendLog(
          {
            token: self.token,
            version: "3.3.0",
            source: "h5",
            extensionJson: {
              type: parseInt(self.bottem_mes.order_status + 1)
            }
          },
          "jz0345"
        );
      } else {
        this.loadingLock = true;
        this.status = "error";
      }
    },
    creatOrder: async function(obj) {
      console.log(obj);
      let self = this;
      let arr = [];
      let productList = {
        productID: self.data.productId,
        num: 1
      };
      arr.push(productList);
      const [resp] = await ajax.all([
        ajax.post("/parent/live/order-add?token=" + self.token, {
          source: obj.source,
          version: obj.version,
          addressId: obj.deviceId,
          identity: "parent",
          userSource: "LIVENETSCHOOL",
          productList: arr,
          clientChannel: obj.channel,
          clientVersion: obj.appVersion,
          deviceBrand: obj.platform,
          deviceModel: obj.platform,
          OSName: obj.platform,
          OSVersion: obj.deviceVersion,
          from: "netschool_zhibo",
          orderTagType: 1,
          orderTagKey: "number",
          orderTagValue: 2012,
          channel: "i_jzhz"
        })
      ]);
      console.log(resp.data);
      if (resp.data.code == 99999) {
        self.bottem_mes.btn_status = true;
        self.load = false;
        let result = resp.data.data;
        self.orderId = result.orderId;
        if (this.data.salePrice == 0) {
          return this.$router.push({
            path:
              "/lesson/pay_sucess?token=" +
              self.token +
              "&sourceId=" +
              self.sourceId +
              "&version=" +
              self.version +
              "&source=" +
              self.source +
              "&hideTitleBar=1"
          });
        }
        let url =
          window.location.origin +
          "/#/lesson/pay_sucess?token=" +
          self.token +
          "&version=" +
          self.version +
          "&source=" +
          self.source +
          "&sourceId=" +
          self.sourceId +
          "&hideTitleBar=1";
        window.location =
          "hybird://method/payLiveCourse?orderId=" +
          self.orderId +
          "&successUrl=" +
          escape(url);
      } else {
        self.load = false;
        self.bottem_mes.btn_status = true;
        self.toast = resp.data.msg;
      }
    },
    click_pay: function() {
      let self = this;
      utils.sendLog(
        {
          token: self.token,
          version: "3.3.0",
          source: "h5",
          extensionJson: {
            type: parseInt(self.bottem_mes.order_status + 1)
          }
        },
        "jz0346"
      );
      if (this.bottem_mes.order_status == 2) {
        return (this.tips = "method");
      }
      if (this.bottem_mes.order_status == 1) {
        let url =
          window.location.origin +
          "/#/lesson/pay_sucess?token=" +
          self.token +
          "&version=" +
          self.version +
          "&source=" +
          self.source +
          "&sourceId=" +
          self.sourceId +
          "&hideTitleBar=1";
        return (window.location =
          "hybird://method/payLiveCourse?orderId=" +
          self.orderId +
          "&successUrl=" +
          escape(url));
      }
      this.bottem_mes.btn_status = false;
      this.load = true;
      // let obj = '{"deviceVersion":"11.0.1","version":"332","channel":"AppStore","buildVersion":"3.3.3.1","deviceId":"563E7F43-6399-440C-99E6-F163A95DA408","source":"iOSRCParent","deviceType":"iOSx8664Simulator","packageName":"com.appKnowin.PRapidCalculation","platform":"iOS","appName":"RCParent","token":"MxTARa2dBPmM5QtYb1mdLkoZ_xmE6rNau_v653LR9hPc0k7zbqmdHiYesG9kI0SFK4DGaFPsMpiEUTnF3Ij0D4SO-Dx4JUwqF02DC86hg_o\/","mode":0,"appVersion":"3.3.2"}'
      // this.creatOrder(JSON.parse(obj))
      window.location = "hybird://method/nativeToJS?funcName=callback";
    },
    copy_event: function() {
      window.location = "hybird://method/copy2Clipboard?content=vip.knowbox.cn";
    },
    call_event() {
      window.location =
        "hybird://method/openBrowser?url=" + decodeURI("tel://400-010-0180");
    }
  },
  components: {
    lesson_loading,
    titleBar,
    lesson_bottom
  },
  created: function() {
    let self = this;
    self.token = utils.getQueryString("token");
    self.sourceId = utils.getQueryString("sourceId");
    self.version = utils.getQueryString("version");
    self.source = utils.getQueryString("source");
    vm = this;
    self.initData();
  }
};
</script>

<style lang="scss" scoped>
.lessonDetail {
  padding-top: 0.88rem;
  margin-bottom: 1.1rem;
  background: #f5f5f5;
  .headItem {
    // margin-top: .88rem;
    // height: 4.9rem;
    background: #fff;
    padding: 0 0.3rem;
    .item {
      padding: 0.5rem 0 0.4rem;
      // border-bottom: 1px solid #eeeeee;
      h2 {
        margin-bottom: 0.2rem;
        line-height: 0.4rem;
        font-family: PingFangSC-Medium;
        font-size: 0.32rem;
        color: #56586a;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        i {
          margin-right: 0.1rem;
          display: inline-block;
          width: 0.34rem;
          height: 0.34rem;
          line-height: 0.34rem;
          border-radius: 0.08rem;
          border: solid 1px #ff5959;
          font-family: PingFangSC-Medium;
          font-size: 0.22rem;
          color: #ff5c5c;
          text-align: center;
          vertical-align: top;
        }
      }
      .timeItem {
        span {
          &:last-child {
            margin-left: 0.1rem;
          }
        }
        line-height: 0.25rem;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #9796a4;
      }
      .lesson_num {
        margin-top: 0.25rem;
        font-family: PingFangSC-Medium;
        font-size: 0.26rem;
        color: #9796a4;
      }
      .lesson_item_mes {
        margin-top: 0.36rem;
        height: 0.54rem;
        .box {
          float: left;
          &:first-child {
            width: 2.5rem;
          }
          img {
            width: 0.5rem;
            height: 0.5rem;
            border-radius: 50%;
            float: left;
          }
          .r_box {
            float: left;
            span {
              margin-left: 0.2rem;
              display: block;
              height: 0.22rem;
              line-height: 0.22rem;
              &:first-child {
                margin-bottom: 0.1rem;
              }
            }
            .name {
              font-family: PingFangSC-Regular;
              font-size: 0.24rem;
              color: #56546c;
            }
            .role {
              font-family: PingFangSC-Regular;
              font-size: 0.22rem;
              color: #b0b2c0;
            }
          }
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: #eeeeee;
      transform: scale(1, 0.5);
    }
    .tagItem {
      padding: 0.2rem 0;
      p {
        position: relative;
        height: 0.34rem;
        line-height: 0.3rem;
        font-family: PingFangSC-Medium;
        font-size: 0.22rem;
        color: #b6b6c1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:first-child {
          margin-bottom: 0.25rem;
        }
        &:last-child {
          margin-top: 0.25rem;
          padding-right: 0.37rem;
        }
        i {
          margin-right: 0.18rem;
          display: inline-block;
          width: 0.9rem;
          height: 0.34rem;
          line-height: 0.32rem;
          border-radius: 17px;
          border: solid 1px #e7be85;
          color: #e7be85;
          text-align: center;
        }
        span {
          margin-right: 0.2rem;
        }
      }
      .arrow {
        &:after {
          content: "";
          display: block;
          position: absolute;
          top: 0.08rem;
          right: 0;
          width: 0.11rem;
          height: 0.2rem;
          background: url("../../assets/images/detail_right_arrow.png") 0 0 /
            cover no-repeat;
        }
      }
    }
  }
  .content {
    margin-top: 0.2rem;
    padding-top: 0.46rem;
    background: #fff;
    overflow: hidden;
    .title {
      padding: 0 0.3rem;
      height: 0.36rem;
      line-height: 0.36rem;
      font-family: PingFangSC-Medium;
      font-size: 0.38rem;
      color: #56586a;
      i {
        margin-right: 0.15rem;
        display: inline-block;
        width: 0.08rem;
        height: 0.26rem;
        background-color: #e7be84;
        border-radius: 4px;
      }
      .more {
        display: inline-block;
        float: right;
        font-family: PingFangSC-Medium;
        font-size: 0.28rem;
        color: #9796a4;
        &:after {
          content: "";
          margin-left: 0.2rem;
          display: inline-block;
          width: 0.11rem;
          height: 0.2rem;
          background: url("../../assets/images/detail_right_arrow.png") 0 0 /
            cover no-repeat;
        }
      }
    }
    .lesson_img {
      margin-top: 0.54rem;
      width: 100%;
    }
    .list {
      padding-top: 0.4rem;
      padding-left: 0.24rem;
      margin: 0 0.3rem;
      height: 1.56rem;
      border-bottom: 1px solid #eee;
      &:first-child {
        margin-top: 0.2rem;
      }
      &:last-child {
        border: none;
      }
      span {
        display: block;
        width: 1.13rem;
        height: 0.27rem;
        line-height: 0.27rem;
        font-family: PingFangSC-Medium;
        font-size: 0.28rem;
        color: #f5833c;
      }
      p {
        margin-bottom: 0.22rem;
        height: 0.27rem;
        line-height: 0.27rem;
        font-family: PingFangSC-Medium;
        font-size: 0.28rem;
        color: #56586a;
        &:last-child {
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          color: #9796a4;
        }
      }
    }
    .teacher_mes {
      margin: 0.5rem 0.44rem 0.4rem 0.54rem;
      height: 2.1rem;
      img {
        margin-right: 0.34rem;
        width: 1.65rem;
        height: 2.1rem;
        border-radius: 10px;
      }
      .right_box {
        margin-left: 2rem;
      }
      h3 {
        line-height: 0.33rem;
        margin-bottom: 0.28rem;
        font-family: PingFangSC-Medium;
        font-size: 0.34rem;
        color: #56586a;
        -webkit-overflow-scrolling: touch;
      }
      .tag_item {
        height: 0.36rem;
        margin-bottom: 0.25rem;
        overflow: hidden;
        span {
          display: inline-block;
          margin-right: 0.3rem;
          padding: 0 0.12rem;
          height: 0.36rem;
          line-height: 0.36rem;
          border-radius: 4px;
          border: solid 1px #ff714c;
          color: #ff714c;
        }
      }
      p {
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        line-height: 0.34rem;
        height: 0.96rem;
        color: #8487a0;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    }
  }
  .mark {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.7);
    .tips_middle {
      position: absolute;
      padding: 0.5rem 0.4rem;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 5.8rem;
      height: 3.65rem;
      background-color: #fff;
      border-radius: 0.3rem;
      text-align: center;
      font-family: PingFangSC-Medium;
      h3 {
        font-size: 0.36rem;
        color: #56586a;
      }
      p {
        margin-top: 0.32rem;
        font-size: 0.26rem;
        line-height: 0.39rem;
        color: #8487a0;
      }
      .btn {
        margin-top: 0.2rem;
        overflow: hidden;
        span {
          display: inline-block;
          width: 2.35rem;
          height: 0.89rem;
          line-height: 0.89rem;
          font-size: 0.32rem;
          border-radius: 0.44rem;
          &:first-child {
            float: left;
            color: #e7be84;
            border: solid 1px #e7be84;
          }
          &:last-child {
            float: right;
            color: #fff;
            background-color: #e7be84;
            border: solid 1px #e7be84;
          }
        }
      }
    }
    .tips_bottom {
      position: absolute;
      padding: 0.6rem 0.5rem 0;
      bottom: 0;
      width: 100%;
      height: 4rem;
      background: #fff;
      border-radius: 0.34rem 0.34rem 0 0;
      font-family: PingFangSC-Medium;
      .announce_item {
        height: 2.1rem;
        overflow: hidden;
        h3 {
          font-size: 0.28rem;
          line-height: 0.42rem;
          color: #9796a4;
        }
      }
      p {
        margin-top: 0.1rem;
        height: 0.46rem;
        line-height: 0.46rem;
        font-size: 0.26rem;
        color: #9796a4;
        span {
          float: right;
          display: inline-block;
          width: 1.3rem;
          height: 0.46rem;
          background-color: #e7be85;
          border-radius: 0.23rem;
          font-size: 0.22rem;
          color: #fff;
          text-align: center;
          a {
            color: #fff;
          }
        }
        &:last-child {
          &:before {
            content: "";
            display: inline-block;
            width: 0.08rem;
            height: 0.08rem;
            border-radius: 50%;
            background-color: #f5833d;
            margin: 0 0.1rem 0.06rem 0.03rem;
          }
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          color: #f5833d;
        }
      }
    }
    h2 {
      margin-bottom: 0.4rem;
      font-size: 0.38rem;
      line-height: 0.46rem;
      color: #56586a;
    }
  }
  .fr {
    float: right;
  }
  .fl {
    float: left;
  }
  .mb_20 {
    margin-bottom: 0.2rem;
  }
  .toast {
    position: fixed;
    width: 3rem;
    height: 1.5rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    line-height: 1.5rem;
    text-align: center;
    color: #fff;
  }
  .load_item {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 4.2rem;
    height: 3.3rem;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 20px;
    z-index: 99;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    color: #ffffff;
    img {
      margin: 0.6rem 0 0.2rem;
      width: 1.28rem;
    }
  }
}
</style>